import {
    INITIAL_AUDIENCE,
    SELECT_MARKETING_AUTOMATION
} from '../../actions/types';

const INITIAL_STATE = 0;

export default (state = INITIAL_STATE, action) => {
    switch (action.type) {
        case INITIAL_AUDIENCE:
            return action.payload.data[0].initialAudienceCount;
        case SELECT_MARKETING_AUTOMATION: //When opening marketing automation, reset the Estimate audience number from old automation
            return 0;
        default:
            return state;
    }
}


// WEBPACK FOOTER //
// ./src/reducers/marketingAutomations/InitialAudienceReducer.js